const DUTY_STATUS_ABBR = {
  on_duty: $localize`ON`,
  driving: 'D',
  sleeper: 'SB',
  off_duty: $localize`OFF`,
  waiting: 'W',
};
export { DUTY_STATUS_ABBR };
